import { name as root } from '../actionTypes';

export const name = `${root}/orderproducts`;

export const FETCH_OFFERS_REQUEST = `${name}/offers/request`;
export const FETCH_OFFERS_SUCCESS = `${name}/offers/success`;
export const FETCH_OFFERS_FAILURE = `${name}/offers/failure`;

export const FETCH_PRICES_REQUEST = `${name}/prices/request`;
export const FETCH_PRICES_SUCCESS = `${name}/prices/success`;
export const FETCH_PRICES_FAILURE = `${name}/prices/failure`;

export const ORDER_SOFTWARE_REQUEST = `${name}/software/request`;
export const ORDER_SOFTWARE_SUCCESS = `${name}/software/success`;
export const ORDER_SOFTWARE_FAILURE = `${name}/software/failure`;

export const ORDER_HARDWARE_REQUEST = `${name}/hardware/request`;
export const ORDER_HARDWARE_SUCCESS = `${name}/hardware/success`;
export const ORDER_HARDWARE_FAILURE = `${name}/hardware/failure`;

export const SELECT_PRODUCT = `${name}/product/select`;

export const SAVE_START = `${name}/save/start`;
export const SAVE_STOP = `${name}/save/stop`;

export const SET_SKIP_SHIPPING_ORDER = `${name}/setSkipShippingOrder`;

export const SET_DISPLAY_TYPE = `${name}/display/set`;